// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aITT","type":"styles_type__1R-VJ","choices":"styles_choices__2a3LJ"};